"use strict";

var _StrictMode;
import '@autoguru/overdrive/dist/reset/globalReset.css';
import '@autoguru/overdrive/dist/reset/globalFonts.css';
import { AsyncBoundary } from '@autoguru/suspense';
import { StrictMode } from 'react';
import { LoggingAgentProvider } from '@autoguru/logs';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { App } from './App';
import { getMfeMountPoint } from 'gdu/dist/lib/mfe';
import * as guruConfigs from '../guru.config';
import { MFE_BASE_PATH } from '@autoguru/global-configs';
import { jsx as _jsx } from "react/jsx-runtime";
const root = getMfeMountPoint({
  mountDOMId: guruConfigs.mountDOMId,
  projectName: __GDU_APP_NAME__
});
const MFE = () => {
  createRoot(root).render(_StrictMode || (_StrictMode = /*#__PURE__*/_jsx(StrictMode, {
    children: /*#__PURE__*/_jsx(LoggingAgentProvider, {
      children: /*#__PURE__*/_jsx(AsyncBoundary, {
        fallback: null,
        children: /*#__PURE__*/_jsx(Router, {
          basename: MFE_BASE_PATH,
          children: /*#__PURE__*/_jsx(App, {})
        })
      })
    })
  })));
};
export default MFE;